// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"18":"bc8cc61c","679":"0c2c177a","963":"53629b42"}[chunkId] + ".js";
};